import Card from "@/components/Card";
import SdgGoal from "@/components/SdgGoal/SdgGoal";
import { SdgGoalResult } from "@/schema/assessment-results/SdgGoalResult";
import { useTranslation } from "react-i18next";

interface SDGRatingsProps {
  score: number;
  sdgGoalResults: SdgGoalResult[];
}

export function SDGRatings({ score, sdgGoalResults }: SDGRatingsProps) {
  const { t } = useTranslation();

  return (
    <Card className="flex flex-col px-6 py-5 gap-y-6">
      <span className="text-cool-gray-700 text-lg">
        {t("achievement-of-sDGs")}
      </span>

      <div className="flex flex-row">
        <div className="py-6 px-4 bg-cool-gray-50 flex flex-col rounded-lg">
          <span className="text-cool-gray-700 text-4xl">
            {score}
            <span className="text-3xl">%</span>
          </span>
          <span>{t("achieved")}</span>
        </div>
        <div className="bg-cool-gray-200 mx-6 w-[1px]" />
        <div className="grow flex flex-col gap-y-5">
          <span className="text-cool-gray-600 text-sm">
            {t("achievement-of-each-sDGs-goal")}
          </span>
          <div className="grid grid-cols-4 gap-1">
            {sdgGoalResults.map(({ id, sdg_goal_id, name, score }) => {
              return (
                <SDGItem
                  key={id}
                  sdgGoalId={sdg_goal_id}
                  name={name}
                  score={score}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Card>
  );
}

interface SDGItemProps {
  sdgGoalId: number;
  name: string;
  score: number | null;
}

function SDGItem({ sdgGoalId, name, score }: SDGItemProps) {
  return (
    <div className="flex gap-x-2">
      <SdgGoal goal={sdgGoalId} />
      <div className="flex flex-col">
        <span className="text-cool-gray-600 text-xs">{name}</span>
        <span className="text-cool-gray-700 font-bold text-2xl">
          {score ?? "--"}
        </span>
      </div>
    </div>
  );
}
